module.exports = __webpack_public_path__ + "static/away-front-add9b8000d802f1c72b215f623127580.png";